import React from 'react';
import BaseClass from '@/pages/BaseClass';

import {
	Form,
	Input,
	InputNumber,
	Button,
	Table,
	Modal,
	Steps,
	Divider,
	Image,
	Popconfirm,
	Radio,
	Result,
	Select,
} from 'antd'
import $ from 'jquery';
import {
	CommonValue,
	CommonConfig,
	ngUrl,
	pcUrl,
	confirm,
	message,
	notify,
	parseTime,
	getQuery,
	httpPost
} from '@/utils/Tools';
import OrderAddress from '@/components/OrderAddress';

const {Column} = Table;
export default class App extends BaseClass
{
	constructor(props)
	{
		super(props);
		
		this.state={
			//是否为积分商品
			'isPoints':0,
			'orderCurrent':0,
			'userInfo':{},
			'selectedGoodsList':[],
			'orderInfo':{
				'order_amount':0,
				'total_amount':null,
				'shipping_method':10,
			},
			'wechatpay_qrcode':'',
			
			'couponList':[],
			'selectedCouponIndex':-1,
			
			'methodList':{},
		};
	}
	
	componentDidMount()
	{
		/*
		this.state.goodsId = this.props.match.params.id;
		let siteUrl = CommonValue.get('site_url');
		this.state.siteUrl = siteUrl;
		
		this.getCategoryList();
		this.getInfo();
		document.title = '展示器材 - ' + CommonValue.get('site_name');
		*/
	}
	
	init({selectedGoodsList,userInfo,orderInfo,orderCurrent,isPoints})
	{
		orderInfo['total_amount'] = null;
		this.setState({
			'userInfo':userInfo,
			'orderInfo':orderInfo,
			'selectedGoodsList':selectedGoodsList,
			'orderCurrent':orderCurrent,
			'isPoints':isPoints,
		});
		this.getCouponList();
		this.getMethodList();
	}
	
	/*
	getCategoryList()
	{
		let url = pcUrl('goods','categoryList');
		httpPost(url)
			.then(data=>{
				this.setState({
					'categoryList':data,
				});
			});
	}
	
	getInfo()
	{
		let url = pcUrl('goods','detail');
		let param = {
			'goods_id':this.state.goodsId,
		};
		httpPost(url,param)
			.then(data=>{
				data['spec_index'] = 0;
				data['quantity'] = 1;
				this.setState({
					'info':data,
				});
				document.title = data['goods_name'] + ' - ' + document.title;
			});
	}
	*/
	
	quantityMinus(index)
	{
		if(index == undefined)
		{
			let info = this.state.info;
			if(info.quantity == 1) return;
			info.quantity -- ;	
			this.setState({
				'info':info,
			});
		}
		else
		{
			let list = this.state.selectedGoodsList;
			let info = list[index];
			
			if(info.quantity == 1) return;
			info.quantity -- ;	
			this.setState({
				'selectedGoodsList':list,
			});
			this.calcPrice();
		}
	}
	
	quantityChange(val,index)
	{
		if(val != +val || val <= 0) return;
		
		if(index == undefined)
		{
			let info = this.state.info;
			info.quantity = val;
			this.setState({
				'info':info,
			});
		}
		else
		{
			let list = this.state.selectedGoodsList;
			let info = list[index];
			
			info.quantity = val;	
			this.setState({
				'selectedGoodsList':list,
			});
			this.calcPrice();
		}
	}
	
	quantityPlus(index)
	{
		if(index == undefined)
		{
			let info = this.state.info;
			info.quantity ++ ;	
			this.setState({
				'info':info,
			});
		}
		else
		{
			let list = this.state.selectedGoodsList;
			let info = list[index];
			
			info.quantity ++ ;	
			this.setState({
				'selectedGoodsList':list,
			});
			this.calcPrice();
		}
	}
	
	calcPrice()
	{
		let selectedGoodsList = this.state.selectedGoodsList;
		let goodsIds = [];
		let quantityList = [];
		let specIndexList = [];
		selectedGoodsList.forEach(row=>{
			goodsIds.push(row['goods_id']);
			quantityList.push(row['quantity']);
			specIndexList.push(row['spec_index']);
		});
		
		let url = pcUrl('goods','calcPrice');
		let param = {
			'goods_ids':goodsIds.join(','),
			'quantity_list':quantityList.join(','),
			'spec_index_list':specIndexList.join(','),
		};
		if(this.state.isPoints)
			param['is_points'] = 1;
		
		httpPost(url,param)
			.then(data=>{
				let orderInfo = this.state.orderInfo;
				orderInfo['order_amount'] = data.total;
				selectedGoodsList.forEach((row,index)=>{
					let goodsId = row['goods_id'];
					if(data[goodsId])
					{
						row['goods_price'] = data[goodsId]['goods_price'];
						row['image_amount'] = data[goodsId]['image_amount'];
						row['pay_amount'] = data[goodsId]['pay_amount'];
					}
				});
				this.setState({
					'orderInfo':orderInfo,
					'selectedGoodsList':selectedGoodsList,
				},()=>{
					this.calcTotalPrice();
				});
			});
	}
	
	calcTotalPrice()
	{
		//if(this.state.selectedCouponIndex == -1) return;
		
		let url = pcUrl('goods','calcTotalPrice');
		let param = {
			'order_amount':this.state.orderInfo['order_amount'],
			//'coupon_sn':this.state.couponList[this.state.selectedCouponIndex]['coupon_sn'],
		};
		if(this.state.selectedCouponIndex == -1)
			param['coupon_sn'] = '';
		else
			param['coupon_sn'] = this.state.couponList[this.state.selectedCouponIndex]['coupon_sn'];
		
		httpPost(url,param)
			.then(data=>{
				let orderInfo = this.state.orderInfo;
				orderInfo['total_amount'] = data['total_amount'];
				this.setState({
					'orderInfo':orderInfo,
				});
			});
	}
	
	showOrder()
	{
		//获取价格
		let url = pcUrl('goods','calcPrice');
		let param = {
			'goods_ids':this.state.goodsId,
			'spec_index_list':this.state.info['spec_index'],
			'quantity_list':this.state.info['quantity'],
		};
		
		httpPost(url,param)
			.then(data=>{
				let userInfo = CommonValue.get('user_info');
				
				let selectedGoodsList = [];
				let goodsInfo = JSON.parse(JSON.stringify(this.state.info));
				let goodsId = goodsInfo['goods_id'];
				//计算商品价格
				if(goodsInfo['goods_spec'])
				{
					goodsInfo['goods_price'] = goodsInfo['goods_spec'][goodsInfo['spec_index']][1];
					goodsInfo['goods_spec'] = goodsInfo['goods_spec'][goodsInfo['spec_index']][0];
				}
				goodsInfo['goods_price'] = data[goodsId]['goods_price'];
				goodsInfo['goods_amount'] = data[goodsId]['goods_amount'];
				goodsInfo['pay_amount'] = data[goodsId]['pay_amount'];
				selectedGoodsList.push(goodsInfo);
				
				let orderInfo = this.state.orderInfo;
				orderInfo['order_amount'] = data.total;
				
				this.setState({
					'userInfo':userInfo,
					'selectedGoodsList':selectedGoodsList,
					'orderInfo':orderInfo,
					'showOrderDialog':true,
					'orderCurrent':0,
				});
				this.getCouponList();
				this.getMethodList();
			});
	}
	
	//获取可用的优惠券列表
	getCouponList()
	{
		let url = pcUrl('coupon','index');
		let param = {
			'real_coupon_status':1,
		};
		param['page_size'] = 0;
		
		httpPost(url,param)
			.then(data=>{
				this.setState({
					'couponList':data.list
				});
			});
	}
	
	getMethodList()
	{
		let url = pcUrl('order','methodList');
		httpPost(url)
			.then(data=>{
				//去掉未知选项
				delete(data[0]);
				
				this.setState({
					'methodList':data,
				});
			});
	}
	
	//删除选中商品
	deleteSelectedGoods(index)
	{
	}
	
	//提交订单
	submitOrder()
	{
		let url = pcUrl('goods','addOrder');
		let addressId = this.orderAddress.getAddressId();
		let param = {
			'address_id':addressId,
			'shipping_method':this.state.orderInfo['shipping_method'],
			'goods_ids':this.state.selectedGoodsList.map(row=>row['goods_id']).join(','),
			'quantity_list':this.state.selectedGoodsList.map(row=>row['quantity']).join(','),
			'spec_index_list':this.state.selectedGoodsList.map(row=>row['spec_index']).join(',')
		};
		if(this.state.selectedCouponIndex != -1)
		{
			param['coupon_sn'] = this.state.couponList[this.state.selectedCouponIndex]['coupon_sn'];
		}
		if(this.state.isPoints)
			param['is_points'] = 1;
		
		httpPost(url,param)
			.then(data=>{
				//公司管理者，进入下一步
				if(+this.state.userInfo['is_manager'])
				{
					let orderInfo = data;
					
					if(!this.state.isPoints)
					{
						this.setState({
							'orderInfo':orderInfo,
							'orderCurrent':1,
						},()=>{
							/*
							this.payForm.setFieldsValue({
								'method':'alipay'
							});
							*/
							this.changeMethod('allinpay');
						});
					}
					else
					{
						let orderSn = orderInfo['order_sn'];
						this.props.history.push('/user/success?order_sn='+orderSn);
					}
				}
				else
				{
					message('订单添加成功，您可以进入订单管理页面查看详情','success',1)
						.then(()=>{
							window.location.href = ngUrl('user','goodsOrder');
						});
				}
			});
	}
	
	changeMethod(method)
	{
		if(method == 'wechatpay')
		{
			this.payForm.validateFields(['method'])
				.then((info)=>{
					info.method = method;
					//微信充值，获取服务器返回的二维码
					this._submit(info)
						.then(data=>{
							this.setState({
								'wechatpay_qrcode':pcUrl('index','qrcode',{ 'code':escape(data.url), }),
							});
							let paySn = data['pay_sn'];
							paySn = paySn.split('_');
							paySn = paySn[0];
							//监听订单状态
							this.loop = window.setInterval(()=>{
								let url = pcUrl('user','payInfo');
								let param = {
									'pay_sn':paySn,
									'check_status':1,
								};
								httpPost(url,param)
									.then(data=>{
										//如果已支付状态
										if(10 == data.status)
										{
											this.props.history.push('/user/success?out_trade_no='+paySn);
										}
									});
							},2000);
						});
					
					this.payForm && this.payForm.setFieldsValue({'method':method});
				});
		}
		else if(method == 'allinpay')
		{
			this.payForm.validateFields(['method'])
				.then((info)=>{
					info.method = method;
					//微信充值，获取服务器返回的二维码
					this._submit(info)
						.then(data=>{
							this.setState({
								'wechatpay_qrcode':pcUrl('index','qrcode',{ 'code':escape(data.url), }),
							});
							let paySn = data['pay_sn'];
							paySn = paySn.split('_');
							paySn = paySn[0];
							//监听订单状态
							this.loop = window.setInterval(()=>{
								let url = pcUrl('user','payInfo');
								let param = {
									'pay_sn':paySn,
									'check_status':1,
								};
								httpPost(url,param)
									.then(data=>{
										//如果已支付状态
										if(10 == data.status)
										{
											//this.props.history.push('/user/success?out_trade_no='+paySn);
											window.location.href = '#/user/success?out_trade_no='+paySn;
										}
									});
							},2000);
						});
					
					this.payForm && this.payForm.setFieldsValue({'method':method});
				});
		}
		else
		{
			if(this.loop)
				window.clearInterval(this.loop);
		
			this.payForm && this.payForm.setFieldsValue({'method':method});
		}
	}
	
	submit(info)
	{
		this._submit(info)
			.then(data=>{
				//支付宝充值，直接进行跳转
				if(info.method == 'alipay')
				{
					document.write(data);
				}
				//余额支付，进入成功页
				else if(info.method == 'moneypay')
				{
					let paySn = data;
					this.props.history.push('/user/success?out_trade_no='+paySn);
				}
			});
	}
	
	_submit(info)
	{
		let url = pcUrl('order','charge');
		let param = {
			'order_id':this.state.orderInfo['order_id'],
			'method': ['alipay','wechatpay','moneypay','allinpay'].indexOf(info.method),
		};
		
		return new Promise((resolve,reject)=>{
			httpPost(url,param)
				.then(data=>{
					resolve(data);
				})
				.catch(e=>reject(e));
		});
	}
	
	render()
	{
		return (
			<>
				<div className="padding-20">
					<Steps current={this.state.orderCurrent} status={this.state.orderCurrent == 2 ?'finish':'process'}>
						<Steps.Step title="生成订单" />
						<Steps.Step title="支付订单" />
						<Steps.Step title="交易成功" />
					</Steps>
				</div>
				<div className="height-20"></div>
				{this.state.orderCurrent == 0 && (
					<>
						<OrderAddress ref={e=>this.orderAddress  = e} />
						<div className="height-30"></div>
						<Divider>所选商品</Divider>
						<Table
							pagination={false} dataSource={this.state.selectedGoodsList} scroll={{'x':true}}>
							<Column title="商品名称" ellipsis={true} width={100} dataIndex="goods_name" />
							<Column title="商品分类" ellipsis={true} width={100} dataIndex="category_name" />
							<Column title="缩略图" ellipsis={true} width={120} dataIndex="goods_thumb" render={(text,row,index)=>(
								<Image src={row['goods_thumb']['thumb_name']} preview={{src:row['goods_thumb']['image_name']}} height={80} />
							)} />
							
							{!this.state.isPoints ? (
							<Column title="商品价格" ellipsis={true} width={100} dataIndex="goods_price" render={(text,row,index)=>'￥'+row['goods_price']} />
							):(
							<Column title="商品积分" ellipsis={true} width={100} dataIndex="goods_price" render={(text,row,index)=>row['goods_price']+'积分'} />
							)}
							<Column title="商品规格" ellipsis={true} width={100} dataIndex="goods_spec" />
							<Column title="数量" ellipsis={true} width={100} dataIndex="quantity" render={(text,row,index)=>(
									<span className="quantity-select">
										<button className="button button-border" onClick={()=>this.quantityMinus(index)}> - </button>
										<input className="input-text" value={row['quantity']} onChange={e=>this.quantityChange(e.target.value,index)} />
										<button className="button button-border" onClick={()=>this.quantityPlus(index)}> + </button>
									</span>
							)} />
							{!this.state.isPoints ? (
								<Column title="原价" ellipsis={true} width={100} dataIndex="goods_amount" render={(text,row,index)=>'￥'+row['goods_amount']} />
							):(
								<Column title="原价" ellipsis={true} width={100} dataIndex="goods_amount" render={(text,row,index)=>row['goods_amount']+'积分'} />
							)}
							{!this.state.isPoints ? (
								<Column title="应付金额" ellipsis={true} width={100} dataIndex="pay_amount" render={(text,row,index)=>'￥'+row['pay_amount']} />
							):(
								<Column title="应付" ellipsis={true} width={100} dataIndex="pay_amount" render={(text,row,index)=>row['pay_amount']+'积分'} />
							)}
							{/*
								<Column title="操作" fixed="right" ellipsis={true} width={100} key="operate" render={(text,row,index)=>(
									<>
									{this.state.selectedGoodsList.length >1? (
										<Popconfirm
											title="确认删除该记录吗?"
											onConfirm={()=>this.deleteSelectedGoods(index)}
											onCancel={()=>{}}
											>
											<a href="javascript:;" className="text-red">删除</a>
										</Popconfirm>
									):''}
									</>
								)} />
							*/}
						</Table>
						<div className="height-10"></div>
						<div className="pay-foot">
							<div style={{'margin-right':'-1em','margin-bottom':'1em'}}>
								选择配送方式：
								&nbsp;
								<Radio.Group value={this.state.orderInfo['shipping_method']} onChange={e=>{let val = e.target.value;let orderInfo = this.state.orderInfo;orderInfo['shipping_method']=val;this.setState({'orderInfo':orderInfo});}}>
									{Object.keys(this.state.methodList).map(key=>(
										<Radio value={+key}>{this.state.methodList[key]}</Radio>
									))}
								</Radio.Group>
							</div>
							<h3>
								{!this.state.isPoints?(
								<>
									总计：
									<span className="text-red">
										￥{this.state.orderInfo['order_amount']}
									</span>
									元
								</>
								):(
								<>
									总计：
									<span className="text-red">
										{this.state.orderInfo['order_amount']}
									</span>
									&nbsp;
									<span style={{'font-size':'80%'}}> 积分 </span>
								</>
								)}
							</h3>
							{!this.state.isPoints && this.state.couponList.filter(row=>+row['min_expense']<=this.state.orderInfo['order_amount']).length ? (
								<div>
									<div style={{'background-color':'#F9F9F9','border-radius':'5px','padding':'1em 1.5em 1em 3em','display':'inline-block'}}>
										<p>
											选择优惠券：
											<Select style={{'width':'10em','text-align':'center'}} placeholder="选择优惠券" value={this.state.selectedCouponIndex} onChange={index=>{if(index == undefined) index = -1;this.setState({'selectedCouponIndex':index},()=>{this.calcTotalPrice();});}}>
												<Select.Option value={-1}>不使用优惠券</Select.Option>
												{this.state.couponList.filter(row=>+row['min_expense']<=this.state.orderInfo['order_amount']).map((row,index)=>(
													<Select.Option value={index} title="123">满{+row['min_expense']}元减{+row['coupon_amount']}元</Select.Option>
												))}
											</Select>
										</p>
										{this.state.selectedCouponIndex != -1 && (
											<p>
												<span className="text-red">
													- ￥{+this.state.couponList[this.state.selectedCouponIndex]['coupon_amount']}
												</span>
												元
											</p>
										)}
									</div>
								</div>
							):''}
							<dl>
								{!this.state.isPoints?(
									<>
										<dt>总价</dt>
										<dd>
											<span className="text-red"> ￥{this.state.orderInfo['total_amount'] != null ? this.state.orderInfo['total_amount']:this.state.orderInfo['order_amount']} </span>
											元
										</dd>
									</>
								):(
									<>
										<dt>总价</dt>
										<dd>
											<span className="text-red"> {this.state.orderInfo['total_amount'] != null ? this.state.orderInfo['total_amount']:this.state.orderInfo['order_amount']}</span>
											&nbsp;
											<span style={{'font-size':'80%'}}> 积分 </span>
										</dd>
									</>
								)}
							</dl>
						</div>
					</>
				)}
				{this.state.orderCurrent == 1 && (
					<>
						<div className="pay-head">
							<dl>
								<dt>
									应付金额：
									<span className="text-red"> ￥{this.state.orderInfo['order_amount']} </span>
								</dt>
								<dd>
									订单编号：{this.state.orderInfo['order_sn']}
								</dd>
								<dd>
									提交时间：{parseTime(this.state.orderInfo['add_time'])}
								</dd>
							</dl>
						</div>
						<div className="height-20"></div>
						<Form
							ref={e=>this.payForm = e}
							onFinish={(data)=>this.submit(data)}
							onFinishFailed={data=>this.focusError(data)}
							labelCol={{ span:3 }}
							wrapperCol={{ span:20 }}>
							<Form.Item name="method" label="支付方式">
								<Form.Item shouldUpdate>
									{()=>(
										<>
											<div className="pay-method">
												<ul>
													{/*
														<li onClick={()=>this.changeMethod('alipay')}>
															<Radio checked={this.payForm && this.payForm.getFieldValue('method') == 'alipay'} value="alipay"></Radio>
															<img className="alipay-icon" src={require("@/assets/images/alipay.png")} />
														</li>
														<li onClick={()=>this.changeMethod('wechatpay')}>
															<Radio checked={this.payForm && this.payForm.getFieldValue('method') == 'wechatpay'} value="wechatpay"></Radio>
															<img className="wechatpay-icon" src={require("@/assets/images/wechatpay.jpg")} />
														</li>
													*/}
													<li onClick={()=>this.changeMethod('allinpay')}>
														<Radio checked={this.payForm && this.payForm.getFieldValue('method') == 'allinpay'} value="allinpay"></Radio>
														<img className="wechatpay-icon" src={require("@/assets/images/allinpay.png")} />
													</li>
													<li onClick={()=>this.changeMethod('moneypay')}>
														<Radio checked={this.payForm && this.payForm.getFieldValue('method') == 'moneypay'} value="moneypay"></Radio>
														<img className="wechatpay-icon" src={require("@/assets/images/money_pay.jpg")} />
													</li>
												</ul>
											</div>
											{this.payForm && this.payForm.getFieldValue('method') == 'wechatpay' && (
												<div className="pay-area">
													<div className="pay-area-left">
														<div className="pay-qr">
															{/*
															<img src={require("@/assets/images/wechat_qr.jpg")} />
															*/}
															<img src={this.state.wechatpay_qrcode} />
														</div>
														<div className="pay-attention">
															<dl>
																<dd className="float-left">
																	<img src={require('@/assets/images/wechatpay_focus_ico.jpg')} />
																</dd>
																<dt>
																	请使用微信扫一扫
																	<br/>
																	扫描二维码以完成支付
																</dt>
															</dl>
														</div>
													</div>
													<div className="pay-area-right">
														<img src={require("@/assets/images/wechatpay_exp.jpg")} />
													</div>
												</div>
											)}
											{this.payForm && this.payForm.getFieldValue('method') == 'allinpay' && (
												<div className="pay-area">
													<div className="pay-area-left">
														<div className="pay-qr">
															{/*
															<img src={require("@/assets/images/wechat_qr.jpg")} />
															*/}
															<img src={this.state.wechatpay_qrcode} />
														</div>
														<div className="pay-attention">
															<dl>
																<dd className="float-left">
																	<img src={require('@/assets/images/wechatpay_focus_ico.jpg')} />
																</dd>
																<dt>
																	请使用微信或支付宝扫一扫
																	<br/>
																	扫描二维码以完成支付
																</dt>
															</dl>
														</div>
													</div>
												</div>
											)}
										</>
									)}
								</Form.Item>
							</Form.Item>
							{/*
								<Form.Item shouldUpdate label="营业执照">
									{()=>JSON.stringify(this.payForm && this.payForm.getFieldsValue())}
								</Form.Item>
							*/}
							<Form.Item shouldUpdate wrapperCol={{ offset:3 }}>
							{()=>this.payForm && !['wechatpay','allinpay'].includes(this.payForm.getFieldValue('method')) && (
								<Button block type="primary" htmlType="submit" style={{'width':'18em','height':'36px'}}>确认</Button>
							)}
							</Form.Item>
						</Form>
					</>
				)}
				{this.state.orderCurrent == 2 && (
					<>
					<Result
						status="success"
						title="您已经成功支付订单"
						subTitle={(
							<>
							<div style={{'margin-top':'.5em'}}>
									订单编号: 2017182818828182881
								</div>
								<div>
									我们马上为您的订单进行生产处理，您可以在"我的订单"中查看该订单的最新进度.
								</div>
							</>
						)}
						extra={[
							<Button type="primary" key="console">
								我的订单
							</Button>,
							<Button key="console">
								继续下单
							</Button>,
						]}
					/>
					</>
				)}
				<div className="text-right" style={{'padding-top':'.5em'}}>
					{+this.state.userInfo['is_manager']?[
						this.state.orderCurrent != 0 ? (
							<span></span>
						):'',
						this.state.orderCurrent == 0 ? (
							<Button type="primary" onClick={()=>this.submitOrder()}>下一步</Button>
						):'',
					]:(
						<>
							<Button onClick={()=>this.props.onCancel && this.props.onCancel()}>取消</Button>
							&nbsp;&nbsp;&nbsp;
							<Button type="primary" onClick={()=>this.submitOrder()}>确认</Button>
						</>
					)}
				</div>
			</>
		);
	}
}


